import "./App.css";
import Dictaphone from "./Dictaphone";

function App() {
	return (
		<div className="App">
			<div className="App">
				<h1>Hello</h1>
				<Dictaphone />
			</div>
		</div>
	);
}

export default App;
